export enum Routes {
  LOGIN = '/login',
  HOME = '/',
  CATEGORIES = '/categories',
  COUNTRIES = '/countries',
  BRAND = '/brand',
  FEATURE = '/feature',
  GIFTS = '/gifts',
  SPECIFICATIONS = '/specifications',
  SLIDERS = '/sliders',
  PRODUCTS = '/products',
  PRODUCT_MAIN = '/product/main/',
  PRODUCT_SKU = '/product/sku/'
}
